import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { BannerType, BannerView } from "@dotnet/telematics-design-system";

import { OtpInputField } from "components/Auth/shared/OtpInputField";
import { isAuthenticatorType } from "shared/functions";

import { SendOtpCodeToDisableProps } from "../types";

const SendOtpCodeToDisable = ({
    authType,
    error,
    isLoading,
    changeCode
}: SendOtpCodeToDisableProps) => {
    const { t } = useTranslation();

    return (
        <div>
            <OtpInputField
                isLoading={isLoading}
                error={error}
                onChange={changeCode}
                label={
                    isAuthenticatorType(authType)
                        ? undefined
                        : t("Security##2FA##send email code##verification code")
                }
                isRequired
            />

            <BannerView
                bannerType={BannerType.Info}
                title={t(
                    `Security##2FA##disable##send otp code##no access##${authType.toLowerCase()}`
                )}
                css={css({ marginTop: "16px" })}
            />
        </div>
    );
};

export { SendOtpCodeToDisable };
